
import { createTheme } from '@mui/material';


let theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        p: {
          fontWeight: 400,
          fontFamily: "'Montserrat', sans-serif",
        }
      }
    },
  },
  typography: {
    allVariants: {
      fontFamily: "'Montserrat', sans-serif",
      textTransform: 'none',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "1.35",
      color: "#00000099",
      letterSpacing: "0.2px",
      '@media (max-width: 768px)': {
        fontSize: 14
      },
    },
  },
})

export default theme